import joi from 'joi'
import authenticationMethodsLookup from './authenticationMethodsLookup'
import authenticationMethod from './authenticationMethod'

const schema = authenticationMethodsLookup.keys({
  authenticationMethod: authenticationMethod.required(),
  windowRef: joi.object(),
  suppressIDV: joi.boolean().optional(),
  serializedStark: joi.string().optional()
})

export default schema
